import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import { Heading } from './styled';

export interface IHeaderType {
  as?: React.ElementType;
}

const MenuSectionHeading = ({ children, as = 'h1', ...props }: IBaseProps & IHeaderType) => (
  <Heading as={as} {...props}>
    {children}
  </Heading>
);

export default MenuSectionHeading;
